import React from 'react';

import { HStack, Icon, InlineAlert } from '@rbilabs/universal-components';
import { useIntl } from 'react-intl';

import ActionButton, { ActionButtonVariants } from 'components/action-button';
import { usePrepaidsPaymentMethods } from 'hooks/prepaid/use-prepaids-payment-methods';
import { useUIContext } from 'state/ui';

import { IPaymentRedesign, PaymentRedesign } from '../payment-redesign/payment-redesign';

import { InstructionText, InstructionsContainer, LoadContainer, ReloadWrapper } from './styled';

const PaymentReloadRedesign: React.FC<React.PropsWithChildren<IPaymentRedesign>> = ({
  reloadAmount,
  reloadPaymentValues,
  setReloadPaymentValues,
  methods,
  onChange,
}) => {
  const { formatMessage } = useIntl();
  const { formatCurrencyForUser } = useUIContext();
  const { reloadPaymentMethods, selectedReloadPaymentMethod } = usePrepaidsPaymentMethods();

  const formattedReloadAmount = formatCurrencyForUser(reloadAmount);

  const reloadExplanationText = formatMessage(
    { id: 'reloadExplanation.bk' },
    { reloadAmount: formattedReloadAmount }
  );
  const youWillBeChargedText = formatMessage(
    { id: 'youWillBeCharged' },
    { reloadAmount: formattedReloadAmount }
  );
  const reloadExplanationAndChargedAmountText = `${reloadExplanationText} ${youWillBeChargedText}`;

  return (
    <ReloadWrapper>
      <InlineAlert
        message={reloadExplanationAndChargedAmountText}
        status="info"
        backgroundColor="#FFCFAD"
        ml="$4"
        mr="$4"
      />
      <LoadContainer>
        <InstructionsContainer>
          <InstructionText>{formatMessage({ id: 'loadWith' })}:</InstructionText>
        </InstructionsContainer>
        {reloadPaymentMethods.length > 0 ? (
          <PaymentRedesign
            methods={methods}
            selectedMethodId={selectedReloadPaymentMethod?.fdAccountId || ''}
            reloadAmount={reloadAmount}
            reloadPaymentValues={reloadPaymentValues}
            setReloadPaymentValues={setReloadPaymentValues}
            isDelivery={false}
            showReloadPaymentMethods={false}
            onChange={onChange}
          />
        ) : (
          <HStack width="full" justifyContent="space-between" paddingX="$4">
            <ActionButton
              testID="add-reload-payment-btn"
              width="100%"
              height="$10"
              marginY="$6"
              _text={{ fontSize: 'sm' }}
              variant={ActionButtonVariants.OUTLINE}
              leftIcon={<Icon variant="add" aria-hidden />}
              onPress={onChange}
            >
              {formatMessage({ id: 'addPayment' })}
            </ActionButton>
          </HStack>
        )}
      </LoadContainer>
    </ReloadWrapper>
  );
};

export default PaymentReloadRedesign;
